import { ref, readonly, computed } from 'vue';
import { modalController } from '@ionic/vue';
import BottomSheet, { BottomSheetProps } from '@/organisms/BottomSheet.vue';
import type { ComponentRef } from '@ionic/core';

type BottomSheetPayload = unknown;

const currentModal = ref();
const payload = ref<BottomSheetPayload | null>(null);

export function useBottomSheet<T = BottomSheetPayload>() {
  async function open(
    BottomSheetComponent: ComponentRef,
    props?: BottomSheetProps & any,
    data?: T,
    canDismiss = true,
  ) {
    // Guard : évite deux modals en même temps (double-tap, appels concurrents)
    if (currentModal.value) {
      return currentModal.value.onWillDismiss();
    }

    payload.value = data ?? null;
    currentModal.value = await modalController.create({
      canDismiss,
      component: BottomSheetComponent ?? BottomSheet,
      componentProps: props,
      initialBreakpoint: 1,
      breakpoints: [1],
      cssClass: 'bottom-sheet-custom',
    });

    await currentModal.value.present();

    const result = await currentModal.value.onWillDismiss();
    currentModal.value = undefined;
    payload.value = null;
    return result;
  }

  async function close(result?: unknown) {
    await currentModal.value?.dismiss(result);
    currentModal.value = undefined;
    payload.value = null;
  }

  return {
    isOpen: computed(() => !!currentModal.value),
    payload: readonly(payload),
    open,
    close,
  };
}
